import bootstrapper from '../../bootstrapper';

export const track = async (args) => {
  const trackSeshatEventsUrl = `${window.location.origin}/payment_events`;
  const CSRFToken = document.querySelector('meta[name="csrf-token"')?.content;
  const seshatData = JSON.parse(document.querySelector('head').getAttribute('data-trackpoint-meta'));
  const body = {
    event_name: args.eventName,
    ...args.options,
    ...seshatData,
  };

  return fetch(trackSeshatEventsUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json; charset=UTF-8',
      'X-CSRF-Token': CSRFToken,
    },
    body: JSON.stringify(body),
  });
};

export default () => {
  if (bootstrapper.seshatEnabled) {
    document.querySelectorAll('[data-seshat]').forEach((element) => {
      const event = JSON.parse(element.dataset.seshat);

      if (event.type) {
        element.addEventListener(event.type, (e) => {
          e.preventDefault();

          track({ eventName: event.event, options: event.options });
        });
      } else {
        track({ eventName: event.event, options: event.options });
      }
    });
  }
};
